import React from 'react'
import { Link } from 'react-router-dom'

const Schedul = () => {
  return (
    <section className="schedule-detail">
  <div className="auto-container">
    <div className="image-box">
      <figure className="image wow fadeIn">
        <Link 
          to ="images/resource/schedule-detail.jpg"
          className="lightbox-image"
        >
          <img src="/assets/images/resource/schedule-detail.jpg" alt="" />
        </Link> 
      </figure>
    </div>
    <div className="content-box">
      <div className="upper-box">
        <div className="speaker-info">
          <figure className="thumb">
            <img src="/assets/images/resource/thumb-3.jpg" alt="" />
          </figure>
          <span className="icon fa fa-microphone" />
          <h5 className="name">Gabrielle Winn</h5>
          <span className="designation">Insurance consultant</span>
        </div>
        <ul className="upper-info">
          <li>
            <span className="icon far fa-calendar-alt" /> 12/31/2023
          </li>
          <li>
            <span className="icon fa fa-paper-plane" />
            203 Madison Ave, NY, USA
          </li>
        </ul>
        {/* <Link  to ="buy-ticket.html" className="theme-btn btn-style-two">
          <span className="btn-title">Book Ticket</span>
        </Link>  */}
      </div>
      <h2>Home Life Open Entryway Open Occasion of 21</h2>
      <p>
        {" "}
        Dolor sit amet consectetur elit sed do eiusmod tempor incd idunt labore
        et dolore magna aliqua enim ad minim veniam quis nostrud exercitation
        ullamco laboris nisi ut aliquip exea commodo consequat.duis aute irure
        dolor in repre hen derit in voluptate velit esse cillum dolore eu fugiat
        nulla pariatur cepteur sint occaecat cupidatat eaque ipsa quae illo
        proident sunt in culpa qui officia deserunt mollit anim id est laborum
        perspiciatis unde omnis iste natus error sit voluptatem accusantium
        dolore laudant rem aperiam eaque ipsa quae ab illo inventore veritatis
        quasi architecto.
      </p>
      <p>
        {" "}
        Dolor sit amet consectetur elit sed do eiusmod tempor incd idunt labore
        et dolore magna aliqua enim ad minim veniam quis nostrud exercitation
        ullamco laboris nisi ut aliquip exea commodo consequat.duis aute irure
        dolor in reprehen derit in voluptate velit esse cillum dolore eu fugiat
        nulla pariatur cepteur sint occaecat cupidatat.
      </p>
      <div className="row two-column">
        <div className="column col-lg-6 col-md-12 order-2">
          <figure className="image">
            <img src="/assets/images/resource/image-2.jpg" alt="" />
          </figure>
        </div>
        <div className="column col-lg-6 col-md-12">
          <h4>Evolution of user Interface</h4>
          <ul className="list-style-one">
            <li>Multiple Announcements during the event.</li>
            <li>Logo &amp; company details on the WordCamp Kolkata.</li>
            <li>Dedicated blog post thanking each of our Gold.</li>
            <li>Acknowledgment and thanks in opening and closing.</li>
            <li>Metting for Globle worming for weather.</li>
          </ul>
        </div>
      </div>
      <p>
        Dolor sit amet consectetur elit sed do eiusmod tempor incd idunt labore
        et dolore magna aliqua enim ad minim veniam quis nostrud exercitation
        ullamco laboris nisi ut aliquip exea commodo consequat.duis aute irure
        dolor in repre hen derit in voluptate velit esse cillum dolore eu fugiat
        nulla pariatur cepteur sint occaecat cupidatat eaque ipsa quae illo
        proident sunt in culpa qui officia deserunt mollit anim id est laborum
        perspiciatis unde omnis iste natus error sit voluptatem accusantium
        dolore laudant rem aperiam eaque ipsa quae ab illo inventore veritatis
        quasi architecto.
      </p>
      <p>
        Dolor sit amet consectetur elit sed do eiusmod tempor incd idunt labore
        et dolore magna aliqua enim ad minim veniam quis nostrud exercitation
        ullamco laboris nisi ut aliquip exea commodo consequat.duis aute irure
        dolor in reprehen derit in voluptate velit esse cillum dolore eu fugiat
        nulla pariatur cepteur sint occaecat cupidatat.
      </p>
    </div>
  </div>
</section>

  )
}

export default Schedul